import { Box } from '@mui/material';
import MapIcon from '../../assets/images/MapIcon.png';
import HelpIcon from '../../assets/images/HelpIcon.png';
import PersonIcon from '@mui/icons-material/Person';
import MapIconSelected from '../../assets/images/MapIconSelected.png';
import HelpIconSelected from '../../assets/images/HelpIconSelected.png';
import RepertoireIcon from '../../assets/images/RepertoireIcon.png';
import RepertoireIconSelected from '../../assets/images/RepertoireIconSelected.png';
import { useNavigate } from 'react-router-dom';
import LogOutButton from '../../Components/LogOutButton';
import Fullscreen from '../../Components/Fullscreen';
import { isCapacitorNative } from 'Utils/Constants';
import './Menu.css';

interface MenuProps {
  selected: string;
}

export const Menu = (props: MenuProps) => {
  const navigate = useNavigate();
  const navMenu = (path: string) => {
    if (path === 'faq') {
      window.open('https://museflow.ai/faq', '_blank');
    } else {
      navigate(`/${path}`);
    }
  };
  const selected = props.selected;

  return (
    <Box className="menu-container-styles">
      <Box
        className="menu-sidebar-fixed"
        sx={{
          backgroundColor: '#1D2F44',
          height: '100%',
          width: 'calc(var(--app-sidebar-width, 100px) - env(safe-area-inset-left))',
          position: 'fixed',
          top: '0px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box className="menu-items-column">
          <Box
            className="menu-logo-wrap"
            sx={{
              marginTop: '30px',
              marginLeft: '4px',
              marginBottom: '10px',
              maxWidth: '100%',
              '&:hover': { cursor: 'pointer' },
            }}
            onClick={() => navigate('/roadmap')}
          >
            <MenuLogoImg />
          </Box>
          {!isCapacitorNative() &&
            (process.env.REACT_APP_NODE_ENV === 'local' ||
              process.env.REACT_APP_NODE_ENV === 'dev') && (
              <Box
                sx={{
                  '& h6': {
                    color: 'white',
                    margin: 0,
                  },
                }}
              >
                <h6>commit owner:</h6>
                <h6 style={{ marginBottom: '5px', color: 'gray' }}>
                  {process.env.REACT_APP_LAST_COMMIT_OWNER}
                </h6>
                <h6>branch:</h6>
                <h6 style={{ marginBottom: '5px', color: 'gray' }}>
                  {process.env.REACT_APP_BRANCH}
                </h6>
                <h6>commit:</h6>
                <h6 style={{ color: 'gray' }}>{process.env.REACT_APP_LAST_COMMIT}</h6>
              </Box>
            )}

          <Box onClick={() => navMenu('roadmap')} className="menu-hover-box">
            {selected == 'Roadmap' ? (
              <img className="menu-img-styles" src={MapIconSelected} />
            ) : (
              <img className="menu-img-styles" src={MapIcon} />
            )}
            <Box className="menu-text-styles">Roadmap</Box>
          </Box>

          <>
            <Box onClick={() => navMenu('repertoire')} className="menu-hover-box">
              {selected == 'Repertoire' ? (
                <img className="menu-img-styles" src={RepertoireIconSelected} />
              ) : (
                <img className="menu-img-styles" src={RepertoireIcon} />
              )}
              <Box className="menu-text-styles">Repertoire</Box>
            </Box>
          </>

          <Box onClick={() => navMenu('dashboard')} className="menu-hover-box">
            <Box
              sx={{
                borderRadius: '20px',
                // height: '20px',
                width: '40px',
                fontWeight: '600',
                fontSize: '9pt',
                marginRight: '-10px',
                marginLeft: 'auto',
                background: '#28856F',
                color: '#fff',
                marginBottom: '5px',
              }}
            >
              NEW
            </Box>
            {selected == 'Dashboard' ? (
              <svg
                className="menu-img-styles"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="9" stroke="#6F87F1" strokeWidth="1.8" />
                <path
                  d="M12 12L16 8"
                  stroke="#6F87F1"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="M12 12V6" stroke="#6F87F1" strokeWidth="1.2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg
                className="menu-img-styles"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="9" stroke="#ADB1B7" strokeWidth="1.6" />
                <path
                  d="M12 12L16 8"
                  stroke="#ADB1B7"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="M12 12V6" stroke="#ADB1B7" strokeWidth="1" strokeLinecap="round" />
              </svg>
            )}
            <Box className="menu-text-styles">Dashboard</Box>
          </Box>

          <Box onClick={() => navMenu('settings')} className="menu-hover-box">
            <PersonIcon
              sx={{
                color: selected == 'Settings' ? '#6F87F1' : '#ADB1B7',
                fontSize: '32px',
              }}
            />
            <Box className="menu-text-styles">Account</Box>
          </Box>

          <Box onClick={() => navMenu('faq')} className="menu-hover-box">
            {selected == 'FAQ' ? (
              <img className="menu-img-styles" src={HelpIconSelected} />
            ) : (
              <img className="menu-img-styles" src={HelpIcon} />
            )}
            <Box className="menu-text-styles">Help</Box>
          </Box>
        </Box>
        <Box className="menu-sidebar-footer">
          <Box sx={{ ...iconContainerStyles1 }} className="menu-hover-box">
            <LogOutButton />
            <Box className="menu-text-styles" sx={{ marginTop: '0px' }}>
              Log Out
            </Box>
          </Box>
          <Fullscreen show_label={true} />
        </Box>
      </Box>
    </Box>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- shared styles
export const iconContainerStyles1 = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

const MenuLogoImg = () => {
  return (
    <svg xmlns="https://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
      <g clipPath="url(#clip0_2082_973)">
        <path
          d="M34.285 15.9397C33.2255 18.5376 30.5196 25.6453 25.9718 23.3905C25.5715 23.192 25.2296 22.9256 24.9373 22.6044C21.9082 19.2765 25.2484 9.71517 22.1086 9.71436C18.9688 9.71354 19.3212 19.2239 16.974 19.3219C14.6267 19.42 16.1288 12.7041 14.0888 11.7265C12.0488 10.749 11.4861 14.6972 8.82118 20.4425C6.15624 26.1879 2.03496 24.9059 -0.286377 20.4425"
          stroke="white"
          strokeWidth="1.70667"
          strokeLinecap="round"
        />
      </g>
      <rect x="1" y="1" width="32" height="32" rx="16" stroke="white" strokeWidth="1.70667" />
      <defs>
        <clipPath id="clip0_2082_973">
          <rect x="1" y="1" width="32" height="32" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
